import React from "react";

export const InvoiceCollect =  () => {
    return (
        <div>tt</div>
    )
}
